import { DEPENDENCIES } from "../../data/serviceRequestCategories";
import { Field, TextInput, TextArea, SelectInput } from "./formFields";

const budgetOptions = ["PO already issued", "PO in progress", "Not yet budgeted", "Unknown"];

export default function TriageStep({ data, update, toggleDependency }) {
  return (
    <div data-testid="request-triage-step">
      <h2 className="text-xl font-semibold text-gray-900 mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>
        Scale, Support &amp; Reporting
      </h2>
      <p className="text-sm text-gray-500 mb-6">{"Asked on every request \u2014 this is what lets us triage and staff it properly."}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
        <Field label="Expected scale" hint="(audience size, volume, or both)" required testId="request-field-scale">
          <TextInput value={data.scale} onChange={(v) => update("scale", v)} placeholder="e.g. 1,200 partners across EMEA" testId="request-input-scale" />
        </Field>
        <Field label="Budget / PO status" required testId="request-field-budget">
          <SelectInput value={data.budget} onChange={(v) => update("budget", v)} options={budgetOptions} testId="request-input-budget" />
        </Field>
      </div>

      <Field label="Anticipated support needs" hint="(ongoing helpdesk load, not just build effort)" testId="request-field-supportNeeds">
        <TextArea value={data.supportNeeds} onChange={(v) => update("supportNeeds", v)} placeholder="Will this generate ongoing partner-facing tickets? Roughly how many, how often?" testId="request-input-supportNeeds" />
      </Field>

      <Field label="Reporting needs" testId="request-field-reportingNeeds">
        <TextArea value={data.reportingNeeds} onChange={(v) => update("reportingNeeds", v)} placeholder="Who needs to see what, how often, and in what format?" testId="request-input-reportingNeeds" />
      </Field>

      <div className="mb-2">
        <label className="block text-sm font-semibold text-gray-800 mb-2">
          Dependency systems <span className="text-xs text-gray-400 font-normal">(select all that apply)</span>
        </label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
          {DEPENDENCIES.map((dep) => {
            const checked = data.dependencies.includes(dep);
            return (
              <label key={dep} className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer" data-testid={`request-dependency-${dep.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggleDependency(dep)}
                  style={{ accentColor: "#1D5C56" }}
                />
                {dep}
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
}
